const LngLatFormat = {
	NULL: "", // Used on the User when it should refer to the Company setting.
	DECIMAL: "decimal",
	DMS: "degrees-minutes-seconds"
};
export default LngLatFormat;
